import React, { useEffect } from 'react';
import { useRouter } from "next/router";
import { observer } from 'mobx-react-lite';

const GiftCardsPage = observer(() => {
  const router = useRouter();
  useEffect(() => {
    router.push('/');
  }, []);
  return (
    <div></div>
  );
});

export default GiftCardsPage;
